import React from 'react';
import { Dimensions } from 'constants/types';
import {
  getWellDropScoreType,
  useImagesList,
  useIsFetchingData,
  useSearchedAlready,
  useSelectedImage,
  useSelectedImageNumber,
  useSetSelectedImageIndex,
} from './withImageScoringSortContext';
import WellDropImageLoader from 'components/searchAndFilter/components/WellDropImageLoader';
import Paginator from 'components/Pagination';
import NoImage from 'components/generic/noImage';
import NoDataFound from 'components/generic/noDataFound';
import { LoadingDiv } from 'components/generic';
import AutoScoreRenderer from 'components/scores/autoScoresRendererNonCanvas';
import { WellImageScoreDTO } from 'business/models/Models';
import { NavigationSource } from 'utils/Global';

interface Props {}

const FullImageRenderer = (props: Props) => {
  const {} = props;

  const selectedImage = useSelectedImage();
  const selectedImageNumber = useSelectedImageNumber();
  const imagesList = useImagesList();
  const moveSelectedIndex = useSetSelectedImageIndex();
  const isFetchingData = useIsFetchingData();
  const searchedAlready = useSearchedAlready();

  const renderScore = (image: WellImageScoreDTO) => {
    return (
      <AutoScoreRenderer
        width={30}
        height={14}
        scoresOfWellDrops={[
          {
            wellDropScoreId: image.wellDropScoreId,
            autoScoreValue: image.autoScoreValue,
            autoScoreType: getWellDropScoreType(image.wellDropScoreId),
          },
        ]}
      />
    );
  };

  if (!searchedAlready && !isFetchingData) {
    return null;
  }

  if (isFetchingData) {
    return <LoadingDiv />;
  }

  if (!selectedImage) {
    return <NoDataFound />;
  }

  const dimensions: Dimensions = {
    height: parseInt((window.innerHeight * 0.45).toFixed(0)),
    width: window.innerWidth * 0.255,
  }; // ratio of side panel for full image.

  return (
    <>
      <div
        id="sortscoringwellimages-fullimagerenderer-wrapper"
        onDoubleClick={() =>
          window.open(
            `/exp/${selectedImage.experimentId}/${selectedImage.plateId}/${selectedImage.wellNumber}/${selectedImage.dropNumber}/${selectedImage.cpid}/Drop/${selectedImage.imageBatchId}/drop?from=${NavigationSource.Explorer}`,
            '_blank',
          )
        }
        className={`border border-black flex align-center content-center justify-center relative`}
        style={{ height: `${dimensions.height}px` }}
      >
        {selectedImage.image.wellImage ? (
          <>
            <WellDropImageLoader
              captureProfileId={selectedImage.cpid}
              plateId={selectedImage.plateId}
              wellNumber={selectedImage.wellNumber}
              batchId={selectedImage.imageBatchId}
              dropNumber={selectedImage.dropNumber}
              regionId={selectedImage.regionId}
              dimensions={dimensions}
              useCanvasImage={false}
              fetchThumbnail={false}
            />
            <div
              id="sortscoringwellimages-fullimagerenderer-renderscore-wellimage"
              className="absolute top-0 left-0"
            >
              {renderScore(selectedImage)}
            </div>
          </>
        ) : (
          <>
            <NoImage svgProps={{ fill: '#333', width: 150, height: 150 }} />
            <div
              id="sortscoringwellimages-fullimagerenderer-renderscore-not-wellimage"
              className="absolute top-0 left-0"
            >
              {renderScore(selectedImage)}
            </div>
          </>
        )}
      </div>
      <Paginator
        pagination={{ perPage: 1, page: selectedImageNumber, total: imagesList.length }}
        onPageNumberChange={(number: number) => moveSelectedIndex(number - 1)} // -1 because index starts at 0 and we are using number for pagination.
        showRowsPerPage={false}
        showSimplifiedVersion
        containerStyle="mt-2"
      />
    </>
  );
};

export default FullImageRenderer;
